<template>
  <div>
    <el-form-item :label="$t('i18n.b985c54ec0b64c37852c22562475f1ce')" prop="name">
      <el-input
        v-model="form.name"
        maxlength="50"
        show-word-limit
        :placeholder="$t('i18n.a6d61a9d34474ef5bcbb83938e05c756')"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$t('i18n.78209f56e1884816bad4aac43c7a1a7b')" prop="region">
      <el-input
        v-model="form.tips"
        maxlength="100"
        show-word-limit
        disabled
        :placeholder="$t('i18n.2afee910006744ee82e19faabf3add31')"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$t('i18n.e5c05a083c1f43d2858ba4823566770d')" prop="region">
      <transition-group name="slide-fade">
        <div
          class="line-option-box"
          v-for="(item, index) in form.options"
          :key="item.id"
          @drop="event => handleItemDrop(event, index)"
          :draggable="optionsDropState"
          @dragover.prevent
          @dragstart="event => handleDragStart(event, index)"
        >
          <div
            class="option-box-item margin-right"
            v-if="isViewDelOrDrop"
            @mouseenter="handleMouse(true)"
            @mouseleave="handleMouse(false)"
          >
            <i class="el-icon-menu icon-button"></i>
          </div>
          <el-input v-model="item.label" :placeholder="$t('90')"></el-input>
          <div class="option-box-item" v-if="isViewDelOrDrop && form.options.length > 2">
            <i class="icon-button el-icon-close margin-left" @click="handleDel(index)"></i>
          </div>
        </div>
      </transition-group>
      <!-- 添加 -->
      <el-button type="text" @click="handleAdd" class="margin-top">{{
        $t('i18n.fa469d2be21440ac99e3f95c7cec1c44')
      }}</el-button>
    </el-form-item>
    <el-form-item :label="$t('i18n.0a5d225866204083972f74127963080b')" prop="region">
      <el-checkbox v-model="form.require">{{ $t('i18n.ca2f54a11aaf46d49f46588e55bbab1a') }}</el-checkbox>
    </el-form-item>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      optionsDropState: false
    }
  },
  computed: {
    // 是否可拖拽删除
    isViewDelOrDrop: vm => vm.form.options && vm.form.options.length > 1
  },
  methods: {
    handleMouse(state) {
      this.$nextTick(() => {
        this.optionsDropState = state
      })
    },
    // 添加选项
    handleAdd() {
      this.form.options.push({ id: uuidv4(), label: '' })
    },
    // @parma { number } index 下标
    handleDel(index) {
      this.form.options.splice(index, 1)
    },
    // 组件内拖拽开始
    handleDragStart(event, index) {
      event.dataTransfer.setData('index', index)
    },
    // 拖拽结束放置
    handleItemDrop(event, index) {
      event.stopPropagation()
      const { options } = this.form
      // 首先获取将要换位的组件
      const paramIndex = +event.dataTransfer.getData('index')
      const target = options.splice(paramIndex, 1)[0]
      // 然后拿到之后插入到目标位置
      options.splice(index, 0, target)
    }
  }
}
</script>
